import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mx-auto p-2 pl-8 pr-8 text-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 text-xl font-bold" }, " On-Chain Canvas (beta, Goerli network) ", -1)
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "mb-4 flex flex-wrap" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "ml-2 mr-2 flex justify-between"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "edit", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "delete", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons text-9xl" }, "add", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "mb-2" }
const _hoisted_17 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Canvas = _resolveComponent("Canvas")!
  const _component_drawing_item = _resolveComponent("drawing-item")!
  const _component_MintPanel = _resolveComponent("MintPanel")!
  const _component_NFTList = _resolveComponent("NFTList")!
  const _component_References = _resolveComponent("References")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("draw.message1")) + " " + _toDisplayString(_ctx.$t("draw.message2")), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("draw.message3")) + " " + _toDisplayString(_ctx.$t("draw.message4")) + " " + _toDisplayString(_ctx.$t("draw.message5", { mintPrice: _ctx.mintPrice })) + " " + _toDisplayString(_ctx.$t("draw.message6")), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("draw.message7")) + " " + _toDisplayString(_ctx.$t("draw.message8")) + " " + _toDisplayString(_ctx.$t("draw.message9")), 1),
      (_ctx.showCanvas)
        ? (_openBlock(), _createBlock(_component_Canvas, {
            key: 0,
            onClose: _ctx.onClose,
            class: "z-10",
            drawing: _ctx.selectedDrawing,
            remixes: _ctx.remixes,
            addresses: _ctx.addresses
          }, null, 8, ["onClose", "drawing", "remixes", "addresses"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drawings, (drawing, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  onClick: ($event: any) => (_ctx.onDrawingSelect(index)),
                  class: _normalizeClass(`border-2 ${
              index == _ctx.selectedIndex ? 'border-blue-700' : 'border-white'
            }`)
                }, [
                  _createVNode(_component_drawing_item, { drawing: drawing }, null, 8, ["drawing"]),
                  (index == _ctx.selectedIndex)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("button", {
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onOpen && _ctx.onOpen(...args)))
                        }, _hoisted_11),
                        _createElementVNode("div", null, [
                          _createElementVNode("button", {
                            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDelete && _ctx.onDelete(...args)), ["stop"]))
                          }, _hoisted_13)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_8))
              }), 128)),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onCreate && _ctx.onCreate(...args)))
                }, _hoisted_15)
              ])
            ]),
            (_ctx.selection)
              ? (_openBlock(), _createBlock(_component_MintPanel, {
                  key: 0,
                  selection: _ctx.selection,
                  tokenAbi: _ctx.tokenAbi,
                  addresses: _ctx.addresses,
                  tokensPerAsset: _ctx.tokensPerAsset,
                  assetStoreRO: _ctx.assetStoreRO,
                  priceRange: _ctx.priceRange,
                  drawing: _ctx.selectedDrawing,
                  mintPrice: _ctx.mintPrice,
                  onMinted: _ctx.minted
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$tc("mintPanel.cc0Message")), 1),
                    _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$tc("mintPanel.drawMessage", { mintPrice: _ctx.mintPrice })), 1)
                  ]),
                  _: 1
                }, 8, ["selection", "tokenAbi", "addresses", "tokensPerAsset", "assetStoreRO", "priceRange", "drawing", "mintPrice", "onMinted"]))
              : _createCommentVNode("", true)
          ])),
      _createVNode(_component_NFTList, {
        tokens: _ctx.tokens,
        OpenSeaPath: _ctx.OpenSeaPath,
        isRecent: true
      }, null, 8, ["tokens", "OpenSeaPath"]),
      _createVNode(_component_References, {
        EtherscanStore: _ctx.EtherscanStore,
        EtherscanToken: _ctx.EtherscanToken,
        TokenName: _ctx.tokenName
      }, null, 8, ["EtherscanStore", "EtherscanToken", "TokenName"])
    ])
  ]))
}